import {
  iActionLogout,
  AuthTypes,
} from '~/domain/interfaces/redux/auth/Logout';

export const logout = (): iActionLogout => ({
  type: AuthTypes.LOGOUT,
});
